import * as Yup from "yup";

const loginValidation = Yup.object().shape({
  email: Yup.string().email().required("Email is Required"),
  password: Yup.string().trim().min(5).required("Password is Required"),
});

export { loginValidation };
